/**
 * Floating WhatsApp Button Component
 * Simple web component for always-visible WhatsApp button
 */

class FloatingWhatsapp extends HTMLElement {
  constructor() {
    super();
    this.button = null;
  }

  connectedCallback() {
    this.button = this.querySelector('.whatsapp-button');
    
    if (!this.button) return;

    // Add click event listener for analytics tracking
    this.button.addEventListener('click', this.handleClick.bind(this));

    // Shopify theme editor support
    if (Shopify && Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleClick.bind(this));
    }

    if (Shopify && Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
    }
  }

  handleClick(event) {
    // Track WhatsApp button click (optional - for analytics)
    this.trackClick();

    // Optional: Add custom behavior before opening WhatsApp
    // event.preventDefault(); // Uncomment to prevent default behavior
  }

  trackClick() {
    // Google Analytics tracking (if available)
    if (typeof gtag !== 'undefined') {
      gtag('event', 'click', {
        'event_category': 'WhatsApp',
        'event_label': 'Floating Button Click',
        'value': 1
      });
    }

    // Facebook Pixel tracking (if available)
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Contact', {
        content_name: 'WhatsApp Button Click'
      });
    }

    // Shopify Analytics (if available)
    if (typeof ShopifyAnalytics !== 'undefined') {
      ShopifyAnalytics.lib.track('WhatsApp Button Click', {
        source: 'floating_button'
      });
    }

    // Console log for debugging
    console.log('WhatsApp button clicked');
  }

  onSectionLoad(event) {
    if (event.detail && event.detail.sectionId === this.closest('.shopify-section').dataset.sectionId) {
      // Refresh component when section is loaded in theme editor
      console.log('Floating WhatsApp section loaded');
    }
  }

  onSectionSelect(event) {
    if (event.detail && event.detail.sectionId === this.closest('.shopify-section').dataset.sectionId) {
      // Highlight or focus the button when section is selected in theme editor
      if (this.button) {
        this.button.classList.add('pulse');
        setTimeout(() => {
          this.button.classList.remove('pulse');
        }, 3000);
      }
    }
  }
}

// Register the custom element
customElements.define('floating-whatsapp', FloatingWhatsapp);
